import React, { useEffect } from "react";
import { Route, RouteProps } from "react-router-dom";

import { setLoginMethod } from "Store/analytics/analyticsSlice";
import { isAuthenticated, login } from "Utils/KeycloakWrapper";
import { Login } from "Utils/analytics";
import { useDispatch } from "react-redux";

export const ProtectedRoute = (
  props: RouteProps,
): React.ReactElement | null => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(setLoginMethod(Login.BANK_ID));
    }
  }, []);

  if (!isAuthenticated()) {
    login();
    return null;
  }
  return <Route {...props} />;
};
